import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import Menu from 'react-burger-menu/lib/menus/slide';
import { getBaseTheme } from '@Themes';
import { ArrowBack } from '../UI/Icons/arrowBack';

const { texts, spaces, colors } = getBaseTheme();

export const StyledDrawer = styled(Menu)({
    background: colors.area.default.complementaryBackgroundColor,
    padding: spaces.default.m,
    top: 0,
    left: 0
});

export const DrawerContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateZ(0)',
    height: 'calc(100% - 40px)',
    '&:focus': {
        outline: 'none'
    }
});

export const Header = styled.div({
    display: 'flex !important',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: spaces.inline.m,

    '&:focus': {
        outline: 'none'
    }
});

export const Title = styled(textblocks.Text)`
    ${texts.sizes.l};
`;

export const TitleContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
});

export const StyledArrow = styled(ArrowBack)({
    cursor: 'pointer'
});
